import { render, staticRenderFns } from "./MySendSelect.vue?vue&type=template&id=11e4bd62&"
import script from "./MySendSelect.vue?vue&type=script&lang=js&"
export * from "./MySendSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports